import { SxProps } from '@mui/material';

const tableHeader: SxProps = {
  backgroundColor: 'customGrey.light'
};

const messageBubbleContainer: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
  mb: 3
};

export const openingMessagesTableSx = {
  tableHeader,
  messageBubbleContainer
};
